// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Jxf-","productName":"Table_productName__3N0G4"};